import AnalyticsCardLayout from "../wrapper/AnalyticsCardLayout";
import ApexChart, { Props } from "react-apexcharts";
function LineCard(props: BarCardProps) {
  const {
    title,
    series,
    colors,
    details,
    hasGradient = true,
    height,
    percentageChange,
    type,
    ...rest
  } = props;

  const chartConfig = {
    series,
    options: {
      chart: {
        type: (type || "area") as "area",
        height: 100,
        // width: "100%",
        stacked: true,
        // events: {
        //   selection: function (chart, e) {
        //     console.log(new Date(e.xaxis.min));
        //   },
        // },
      },
      colors: colors || ["#905F6A", "#00E396", "#CED4DC"],
      dataLabels: {
        // enabled: false,
      },
      stroke: {
        curve: "smooth" as "stepline",
      },
      fill: {
        type: hasGradient ? "gradient" : "solid",
        gradient: {
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 0.7,
          opacityTo: 0.9,
          stops: [0, 90, 100],
        },
      },
      legend: {
        position: "top" as "top",
        horizontalAlign: "left" as "left",
      },
      xaxis: {
        categories: rest.xAxis,
        seriesName:"Hello",
        title:{
          text:rest.xAxisLabel},
      },
      yaxis: {
        show: true,
        seriesName: rest.yAxisLabel,
        title:{
          text:rest.yAxisLabel}, 
        labels: {
          show: true,
          showAlways: true,
          title: {
            text: rest.yAxisLabel,
            rotate: -90,
          },
        },
        // seriesName: "rest.yAxisLabel"  as ApexYAxis,
      },
    },
  };
  return (
    <AnalyticsCardLayout
      title={title}
      details={details}
      percentageChange={percentageChange}
      bgcolor={rest.bgcolor}
    >
      <ApexChart
        options={chartConfig.options}
        series={chartConfig.series}
        type={chartConfig.options.chart.type}
        height={330}
        
      />
    </AnalyticsCardLayout>
  );
}

export default LineCard;
